import { Suspense, lazy } from 'react'

import Spinner from 'src/components/common/spinner'

import ErrorBoundary from './errorBoundary'

const View = lazy(() => import('./view'))

const Backstage = () => {
    return (
        <Suspense fallback={<Spinner />}>
            <ErrorBoundary>
                <View />
            </ErrorBoundary>
        </Suspense>
    )
}
export default Backstage
